import { useHackerContext } from "src/shared/contexts";
import { Field } from "src/shared/contexts/HackerContext/types";

/** First name shown on the personalized ink stamp */
export const useFirstName = (): string => {
  const { claimData } = useHackerContext();
  const name =
    (claimData[Field.PREFERRED_NAME] as string | null) ||
    (claimData[Field.SHORT_NAME] as string | null) ||
    (claimData[Field.LEGAL_NAME] as string | null) ||
    "";
  return name.trim().split(" ")[0] ?? "";
};
